const Barba = require('barba.js')
const $ = require('jquery')
const navController = require('./utils/JS/navController')
const setNavActive = require('./utils/JS/setNavActive').init
const preload = require('./utils/JS/preload')
const ProgressBar = require('progressbar.js')
require('jquery.easing')
const $document = $(document)
const $window = $(window)
import 'alpinejs'

$document.ready(() => {

	const bar = new ProgressBar.Line('#preload-bar', {easing: 'easeInOut'})
	const $bar = $("#preload-bar").css({display:"none"})
	var $overlay = $("#preload-overlay")

	preload.init({
		start: function(){
			bar.set(0.33)
			$bar.fadeIn(400)
		},
		progress: function(event){
			bar.set(0.3333+(event.progress*0.6666))
		},
		complete: function(){
			bar.set(1)
			$bar.fadeOut(400)
			if($overlay){
				$overlay.fadeOut(500, function() {
					$overlay = false
				})
			}
		}
	})

	Barba.Pjax.start()

	Barba.Dispatcher.on("newPageReady", function(c, p, html) {
		// global JS for every page
	})

	navController({
		trigger: ".mobile-nav",
		setActive: ".nav-wrap",
		autoClose: ".nav-wrap a",
		html: {
			".mobile-nav .material-icons": "close"
		}
	})

	setNavActive({
		"header .nav li": {
			a: "> a",
			parents: { top: ".nav", element:"li" }
		},
		"header .donate.btn":  "btn-active"
	})


	$('li.scroller').click(function(){
		var gotoElem = "#" + $(this).data('goto')
		var scrollPos = $(gotoElem).position().top
		$("html, body").animate({ scrollTop: scrollPos }, 1000, 'easeInOutQuart');
	})

	function heightAdjuster() {
		var windowHeight = window.innerHeight;
		if ($(window).width() < 601) {
			$('.main').css('height', windowHeight + 'px');
		}
	}
	//heightAdjuster()

	// $(window).on('resize', function(){
	// 	heightAdjuster()
	// })



})



// WEBPACK FOOTER //
// source/js/main.js